var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(new URL(href).pathname).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"70":1,"114":1,"286":1,"315":1,"410":1,"414":1,"428":1,"434":1,"706":1,"735":1,"744":1,"759":1,"827":1,"864":1,"992":1,"1012":1,"1056":1,"1081":1,"1141":1,"1149":1,"1343":1,"1371":1,"1515":1,"1625":1,"1717":1,"1756":1,"1863":1,"1938":1,"1951":1,"1968":1,"1993":1,"2201":1,"2212":1,"2628":1,"2745":1,"2993":1,"3033":1,"3090":1,"3096":1,"3160":1,"3494":1,"3509":1,"3510":1,"3518":1,"3632":1,"3688":1,"3703":1,"3869":1,"3963":1,"4059":1,"4121":1,"4293":1,"4302":1,"4331":1,"4443":1,"4453":1,"4572":1,"4634":1,"4673":1,"4684":1,"4813":1,"4901":1,"4974":1,"4988":1,"5062":1,"5105":1,"5154":1,"5199":1,"5200":1,"5253":1,"5307":1,"5474":1,"5484":1,"5568":1,"5597":1,"5828":1,"6184":1,"6189":1,"6206":1,"6216":1,"6223":1,"6288":1,"6291":1,"6323":1,"6452":1,"6716":1,"6722":1,"7145":1,"7286":1,"7306":1,"7540":1,"7657":1,"7798":1,"8066":1,"8123":1,"8131":1,"8268":1,"8274":1,"8335":1,"8345":1,"8409":1,"8570":1,"8595":1,"8634":1,"8657":1,"8686":1,"9017":1,"9054":1,"9087":1,"9125":1,"9177":1,"9299":1,"9354":1,"9372":1,"9448":1,"9453":1,"9667":1,"9951":1,"9996":1,"9998":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr